import { useEffect, useRef } from 'react';

interface ImagePreloaderOptions {
  loadOnIdle?: boolean;
  idleTimeout?: number;
}

// 图片预加载 Hook
export const useImagePreloader = (
  imagePaths: string[],
  options: ImagePreloaderOptions = {},
) => {
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    // 如果已经加载过，则直接返回
    if (hasLoadedRef.current) return;

    const { loadOnIdle = false, idleTimeout = 2000 } = options;

    // 预加载图片的函数
    const preloadImages = () => {
      imagePaths.forEach((path) => {
        const img = new window.Image();
        img.src = path;
      });
      // 标记为已加载
      hasLoadedRef.current = true;
    };

    if (
      loadOnIdle &&
      typeof window !== 'undefined' &&
      'requestIdleCallback' in window
    ) {
      // 使用 requestIdleCallback 在浏览器空闲时加载
      const idleCallbackId = (window as any).requestIdleCallback(
        () => {
          preloadImages();
        },
        { timeout: idleTimeout },
      );

      return () => {
        if (typeof window !== 'undefined' && 'cancelIdleCallback' in window) {
          (window as any).cancelIdleCallback(idleCallbackId);
        }
      };
    } else {
      // 立即加载
      preloadImages();
    }
  }, []); // 空依赖数组，确保只执行一次
};
